import { Instance, flow, types } from 'mobx-state-tree'
import { fetchPayoutHistoryList } from '../../network/payoutHistory'
import { getSelectedDate } from '../../util/util'
import { paginationSettingsWithDefaultPage1 } from '../static/data'
import { RootStore } from '../store'

const Position = types.model('position', {
  left: types.number,
  top: types.number,
  visible: types.boolean,
})
const DateRange = types.model('date', {
  fromDate: types.Date,
  toDate: types.Date,
  position: Position,
  dateLabel: types.optional(types.string, ''),
})

const Pagination = types.model('Pagination', {
  size: types.optional(types.number, 0),
  totalElements: types.optional(types.number, 0),
  totalPages: types.optional(types.number, 0),
  number: types.optional(types.number, 0),
})

const Payout = types.model({
  date: types.maybeNull(types.string),
  transactionId: types.maybeNull(types.string),
  amount: types.maybeNull(types.string),
  beneficiaryName: types.maybeNull(types.string),
  method: types.maybeNull(types.string),
  utr: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
})

const PayoutHistory = types
  .model('PayoutHistory', {
    list: types.maybeNull(types.array(Payout)),
    selectedDate: DateRange,
    pagination: Pagination,
  })
  .actions((self) => ({
    fetchPayoutHistory: flow(function* fetchPayoutHistory(mid: string) {
      let response
      try {
        response = yield fetchPayoutHistoryList(mid, RootStore.user.session.getTokens)
        self.list = response
      } catch (e) {
        throw new Error(e?.data?.error?.message ?? 'Error while processing request')
      }
      return response
    }),
  }))
  .views((self) => ({}))

export type PayoutHistoryType = Instance<typeof PayoutHistory>
export { Payout, PayoutHistory }
export const PayoutHistoryData = PayoutHistory.create({
  list: [],
  selectedDate: {
    fromDate: getSelectedDate(1),
    toDate: new Date(Date.now()),
    dateLabel: 'Today',
    position: {
      top: 0,
      left: 0,
      visible: false,
    },
  },
  pagination: paginationSettingsWithDefaultPage1,
})
